// Live Map "Follow" toggle (per user). The selection fly-to effect re-runs on
// every positions update; with follow ON the camera chases the selected vehicle
// (today's behaviour), with follow OFF it flies ONCE per selection change and
// then leaves the camera alone. Pure: no React, no map.
export function selectionCameraMove({ follow, selectedId, lastFlownId }) {
  if (selectedId == null) return false;
  if (follow) return true;
  return lastFlownId !== selectedId;
}
